export default __webpack_public_path__ + "static/media/avatarD6.e843e17c.png";